import crypto from 'crypto';
export function generateUniqueInteger() {
  const uniqueId = crypto.randomBytes(6).readUIntBE(0, 6); // 5 bytes for 10 digits
  return uniqueId.toString().slice(0, 13); // Convert to string and take the first 10 characters
}
